import {takeEvery} from 'redux-saga/effects';
import {cardEditorActions} from "./cardEditor.slice";
import {loadEditorSaga} from "./_sagas/loadEditor.saga";
import {saveSaga} from "./_sagas/save.saga";

export function* cardEditorSaga() {
    yield takeEvery(cardEditorActions.loadEditor.type, loadEditorSaga);
    yield takeEvery(cardEditorActions.save.type, saveSaga);
}
